export default __webpack_public_path__ + "static/messages-inline-dialog-4d60caa849c3420be1eb0350359b77e919cd367cb4eb79ffc3c9bb76c3bf9184.jpg";